export const validatorDependenteSemValorAdicional = valoresForm => {
    const arrayDeValidacoes = [
        (verificarParentescoPermitido(valoresForm.Parentesco) && !verificarParentescosComRegrasEspeciais(valoresForm.Parentesco)),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarSemAdicional(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorDependenteSemValorAdicionalObrigatorio = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        verificarParentescosSemValorAdicionalRegrasEspeciais(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarSemAdicional(valoresForm.Categoria),
        !verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorAte64Anos = valoresForm =>{
    const arrayDeValidacoes = [
        (verificarParentescoNaoPermitido(valoresForm.Parentesco) && !verificarParentescosComRegrasEspeciais(valoresForm.Parentesco)),
        idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte64(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorConjugeAte64Anos = (valoresForm, dependentes) =>{
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte64(valoresForm.Idade),
        verificarGrauParentescoConjuge(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorConjugeMaiorIgual65Anos = (valoresForm, dependentes) =>{
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte65(valoresForm.Idade),
        verificarGrauParentescoConjuge(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaiorIgual65Anos = valoresForm =>{
    const arrayDeValidacoes = [
        (verificarParentescoNaoPermitido(valoresForm.Parentesco) && !verificarParentescosComRegrasEspeciais(valoresForm.Parentesco)),
        idadeAte65(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte65(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaeAte64Anos = (valoresForm, dependentes) =>{
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte64(valoresForm.Idade),
        verificarGrauParentescoMae(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaeMaiorIgual65Anos = (valoresForm, dependentes) =>{
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte65(valoresForm.Idade),
        verificarGrauParentescoMae(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPaiAte64Anos = (valoresForm, dependentes) =>{
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte64(valoresForm.Idade),
        verificarGrauParentescoPai(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPaiMaiorIgual65Anos = (valoresForm, dependentes) =>{
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte65(valoresForm.Idade),
        verificarGrauParentescoPai(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)

    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorExConjugeAte64 = (valoresForm, dependentes) =>{
    const arrayDeValidacoes = [
        idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarGrauParentescoExConjuge(valoresForm.Parentesco),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorExConjugeMaiorIgual65 = (valoresForm, dependentes) =>{
    const arrayDeValidacoes = [
        idadeAte65(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarGrauParentescoExConjuge(valoresForm.Parentesco),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMadrastaAte64 = (valoresForm, dependentes) =>{
    const arrayDeValidacoes = [
        idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarGrauParentescoMadrasta(valoresForm.Parentesco),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMadrastaMaiorIgual65 = (valoresForm, dependentes) =>{
    const arrayDeValidacoes = [
        idadeAte65(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarGrauParentescoMadrasta(valoresForm.Parentesco),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPadrastoAte64 = (valoresForm, dependentes) =>{
    const arrayDeValidacoes = [
        idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarGrauParentescoPadrasto(valoresForm.Parentesco),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPadrastoMaiorIgual65 = (valoresForm, dependentes) =>{
    const arrayDeValidacoes = [
        idadeAte65(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarGrauParentescoPadrasto(valoresForm.Parentesco),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorParentescosComRegrasEspeciaisMaiorIgual65 = (valoresForm, dependentes) =>{
    const arrayDeValidacoes = [
        idadeAte65(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorParentescosComRegrasEspeciaisAte64 = (valoresForm, dependentes) =>{
    const arrayDeValidacoes = [
        idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorDependentesComAdicionalElegivelAte64 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        verificarParentescosComAdicionalElegivel(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        idadeAte64(valoresForm.Idade),
        !verificarAdicionalAte65(valoresForm.Categoria),
        !verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorDependentesComAdicionalElegivelMaiorIgual65 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        verificarParentescosComAdicionalElegivel(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        idadeAte65(valoresForm.Idade),
        !verificarAdicionalAte64(valoresForm.Categoria),
        !verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const parentescosComRegrasEspeciais = [
    '01', //pai
    '20008', //padrasto

    '02', //mae
    '20007',  //madrasta

    '10', //esposo
    '32' //ex conjuge
];

export const parentescosSemValorAdicionalObrigatorioEmCasosEspeciais = [
    '01',
    '02',
    '10'
];

export const parentescosComAdicionalElegivel = [
    '20008',
    '20007',
    '32'
];

export const parentescosPermitidos = [
    '01',
    '02',
    '10',
    '10006',
    '15',
    '5',
    '50',
    '32',
    '20008',
    '20007'
];

export const grausEquivalentes = {
    '01': '20008',
    '20008': '01',

    '02': '20007',
    '20007': '02',

    '10': '32',
    '32': '10'
};

const verificarParentescoPermitido = parentesco => {
    const parentescoEncontrado = parentescosPermitidos.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado !== undefined ? true : false;
};

const verificarParentescoNaoPermitido = parentesco => {
    const parentescoEncontrado = parentescosPermitidos.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado !== undefined ? false : true;
};

const verificarParentescosComRegrasEspeciais = parentesco => {
    const parentescoEncontrado = parentescosComRegrasEspeciais.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado ? true : false;
};

const verificarParentescosSemValorAdicionalRegrasEspeciais = parentesco => {
    const parentescoEncontrado = parentescosSemValorAdicionalObrigatorioEmCasosEspeciais.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado ? true : false;
};

const verificarParentescosComAdicionalElegivel = parentesco => {
    const parentescoEncontrado = parentescosComAdicionalElegivel.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado ? true : false;
};

const verificarPossuiDependenteDeGrauEquivalenteSemAdicional = (dependentes, seq, parentesco) => {
    const dependente =  dependentes.find(dependente => {
        const dependenteGrauParentesco = dependente['GrauParentesco.Grau'].trim();
        const dependenteGrauEquivalente = grausEquivalentes[dependenteGrauParentesco];

        const dependenteCategoria = dependente['CategoriaParentesco.Categoria'];

        return (dependenteGrauParentesco === parentesco || dependenteGrauEquivalente === parentesco) && dependenteCategoria === 'ZELO' && dependente.Seq !== seq;});

    return dependente? true : false;
};

const verificarGrauParentescoConjuge = parentesco =>parentesco === '10';

const verificarGrauParentescoMae = parentesco =>parentesco === '02';

const verificarGrauParentescoPai = parentesco =>parentesco === '01';

const verificarGrauParentescoExConjuge = parentesco => parentesco ==='32';

const verificarGrauParentescoMadrasta = parentesco => parentesco ==='20007';

const verificarGrauParentescoPadrasto = parentesco => parentesco ==='20008';

const verificarIdadePreenchida = idade => idade !== '' && idade !== null;
const verificarCategoriaPrenchida = categoria => categoria !== '';
const verificarParentescoPrenchido = parentesco => parentesco !== '';
const verificarSemAdicional = categoria => categoria.trim() !== 'ZELO';
const verificarAdicionalAte64 = categoria => categoria.trim() !== 'ZMA64';
const verificarAdicionalAte65 = categoria => categoria.trim() !== 'ZMM65';
const idadeAte64 = idade => idade <= 64;
const idadeAte65 = idade => idade >= 65;
